module.exports = __webpack_public_path__ + "media/images/icons/wrench-b6216beee9a6a2b978b6f64ff957f9a9.svg";